// extracted by mini-css-extract-plugin
export var filterIncDec = "_3j-0";
export var leftBorder = "_3j-1";
export var rightBorder = "_3j-2";
export var stringInput = "_3j-3";